import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, Button, ModalBody, Modal } from "reactstrap";
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import handImg from '../../../assets/images/front_hand.svg';
import { fetchPaymentOptions, fetchProductListForGeneratePO, fetchFilterListForAllocation, generatePO, saveAdjustedValue, sendPoForManagementApproval, updatePaymentAndActualDate, updatePODetails } from "../../../api/approval";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import SweetAlert from "react-bootstrap-sweetalert";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getStockInHand } from "../../../api/requisition";
import StockRightSideBar from "../StockRightSideBar";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch, useSelector } from "react-redux";
import TuneIcon from '@mui/icons-material/Tune';
import { fetchLocation, fetchWorkflow } from "../../../api/po";

const GeneratePo = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Generate PO'))

    const [approvalrows, setApprovalrows] = useState([]);
    const [gridLoad, setGridLoad] = useState(false);
    const [vendorListLoad, setVendorListLoad] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [modifyRowMap, setModifyRowMap] = useState({});
    const [allocationQtyMap, setAllocationQtyMap] = useState({});
    const [totalSum, setTotalSum] = useState({});
    const [savedItem, setSavedItem] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [isConversion, setIsConversion] = useState(true);
    const [isTax, setIsTax] = useState(false);
    const [sendToManagementModal, setSendToManagementModal] = useState(false)

    //Sweet Alert dynamic handling
    const [sweetAlertTitle, setSweetAlertTitle] = useState('');
    const [sweetAlertType, setSweetAlertType] = useState('');
    const [sweetAlertConfirmButtonText, setSweetAlertConfirmButtonText] = useState('');
    const sweetAlertDisp = (
        alertTitle,
        alertType,
        confirmButtonText
    ) => {
        setSweetAlertTitle(alertTitle);
        setSweetAlertType(alertType);
        setSweetAlertConfirmButtonText(confirmButtonText);
    }
    //Sweet alert ends here


    const [vendorList, setVendorList] = useState([]);
    const [costCentreOptionsList, setCostCentreOptionsList] = useState([])
    const [workflowList, setWorkflowList] = useState([]);

    const [locationList, setLocationList] = useState([]);

    const [workflow, setWorkflow] = useState(null);
    const [costcentreOptions, setCostcentreOptions] = useState([]);
    
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [category, setCategory] = useState(null)
    const [productOptions, setProductOptions] = useState([]);
    const [product, setProduct] = useState(null)

    const [costcentre, setCostcentre] = useState(null);
    const [description, setDescription] = useState(null);
    const [location, setLocation] = useState(null);
    const [comment, setComment] = useState(null);
    const [reference, setReference] = useState(null);
    const [conversionRate, setConversionRate] = useState(1);

    const [taxInclude, setTaxInclude] = useState(null)
    const [taxOptions, setTaxOptions] = useState([
        {value: 'NO', label: 'NO'},
        {value: 'YES', label: 'YES'}
    ])
    const [selectedVendor, setSelectedVendor] = useState("");
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [isGeneratePOLoading, setGeneratePOLoading] = useState(false);
    const [mergedArray, setMergedArray] = useState(null);
    const [open, setOpen] = useState(false)
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [firstVType, setFirstVType]= useState(null)
    const [isEditMode, setIsEditMode] = useState(true);


    document.title = "Generate PO";

    const [paymentOptions, setPaymentOptions] = useState([]);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [summaryModalIsOpen, setSummaryModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const [generateModal, setGenerateModal] = useState(false)
    const [requisitionModal, setRequisitionModal] = useState(false)
    const [errors, setErrors] = useState({
        workflow: false,
        costcentre: false,
        location: false,
        tax_include: false,
        conversion_rate: false
    });   
    const [showList, setShowList] = useState(false);
    const toggleList = () => {
        setShowList(!showList);
    };
    const fetchParamsDataFromBackend = async () => {
        try {

          let response = await fetchWorkflow();

          setWorkflowList(response.data.details.map(el => ({...el, label: el.workflow_name, value: el.workflow_name})));

          let newOptions = {};

          for(let worflow of response.data.details){
            newOptions[worflow.workflow_name] = worflow.procurementCostcentre.map(el => ({...el, label: el.costcentre_name, value: el.costcentre_name}));
          }

          setCostCentreOptionsList(newOptions);

          response = await fetchLocation();

          setLocationList(response.data.locations.map(el => ({...el, label: el.location_name, value:el.location_name})))

        } catch (error) {
          toast.error("Error in fetching params data");
          console.log(error);
        }
      };

      useEffect(() => {
        fetchParamsDataFromBackend();
      }, []);

    
    useEffect(() => {
        let sum = 0;
        for(let v of selectedIds){
            let item = approvalrows.find(el => el.id == v);
            sum += (Number(allocationQtyMap[v]) * item?.Quantity);
        }

        setTotalSum(sum);
    }, [selectedIds, allocationQtyMap]);
    

    useEffect(() => {
        let obj = {};

        for(let {id, MOP} of approvalrows){
            obj[id] = MOP;
        }

        setAllocationQtyMap(obj);
    }, [approvalrows]);
    const handleWorkflowChange = (event, newValue) => {
        setWorkflow(newValue); // newValue could be null when clearing the selection
        setCostcentre(null);
        if (newValue?.value) {
            setCostcentreOptions(costCentreOptionsList[newValue.value]);
        } else {
            setCostcentreOptions([]); // Reset options if no value selected
        }
        setErrors(prev => ({ ...prev, workflow: !newValue }));

    };
    const handleCostCentreChange = (event, newValue) => {
      setCostcentre(newValue)
      setErrors(prev => ({ ...prev, costcentre: !newValue }));

    };
    const handleLocationChange = (event, newValue) => {
        setLocation(newValue)
        setErrors(prev => ({ ...prev, location: !newValue }));
  
      };
    const handleTaxIncludeChange = (event, newValue) => {
        setTaxInclude(newValue)
        setErrors(prev => ({ ...prev, tax_include: !newValue }));

      };
      const handleChangeRate = (event) =>{
        setConversionRate(event.target.value  )
        setErrors(prev => ({ ...prev, conversion_rate: !event.target.value }));

      }
      const handleLocation = (event) =>{
        setLocation(event.target.value)
        setErrors(prev => ({ ...prev, location: !event.target.value }));
      }
      const handleDescription = (event) =>{
        setDescription(event.target.value)
      }
      const handleReference = (event) =>{
        setReference(event.target.value)
      }
      const handleComments = (event) =>{
        setComment(event.target.value)
      }
    const handleSave = async (id) => {
        try {
            let arr = [...approvalrows];
            let index = arr.findIndex(el => el.id == id);

            let response = await saveAdjustedValue([{
                id: Number(id), 
                adjusted_value: Number(allocationQtyMap[id]),
                prev_mop: arr[index].Single_MOP
            }]);

            if(response.statusCode === 200){
                
                arr[index].ADJUSTED_Value =  allocationQtyMap[id];
                arr[index].MOP =  allocationQtyMap[id];
                arr[index].TOTAL_MOP = arr[index].Quantity * arr[index].MOP;
                setApprovalrows(arr);
                toast.success('Successfully saved FOB value')
                let obj = {...modifyRowMap};
                delete obj[id];
                setModifyRowMap(obj);
                setSavedItem(true);
            }

        }
        catch(error){
            console.log('Error in distributing Quantity purchase manager', error)
            toast.error('Error while saving FOB value')
        }
    }

    const handleSaveAll = async () => {
        try {
            let arr = [...approvalrows];
            let obj = {...modifyRowMap};
            let data = [];
            for(let id of selectedIds){
                let index = arr.findIndex(el => el.id == id);

                data.push({
                    id: Number(id), 
                    adjusted_value: Number(allocationQtyMap[id]),
                    prev_mop: arr[index].Single_MOP
                });
            }

            let response = await saveAdjustedValue(data);


            if(response.statusCode === 200){
                for(let id of selectedIds){
                    let index = arr.findIndex(el => el.id == id);
                    arr[index].ADJUSTED_Value =  allocationQtyMap[id];
                    arr[index].MOP =  allocationQtyMap[id];
                    arr[index].TOTAL_MOP =  arr[index].MOP * arr[index].Quantity;
                    delete obj[id];
                }
            }

            setApprovalrows(arr);
            setModifyRowMap(obj);
            setSavedItem(true);
            toast.success('Successfully saved FOB value')
        }
        catch(error){
            console.log('Error in distributing Quantity purchase manager', error)
            toast.error('Error while saving FOB value')
        }
    }

  const handleEditClick = (value) => {
    if (modifyRowMap[value]) {
      let obj = { ...modifyRowMap };
      delete obj[value];
      setModifyRowMap(obj);
    } else {
      let obj = { ...modifyRowMap };
      obj[value] = true;
      setModifyRowMap(obj);
    }
  };

    const handleIdSelection = (e, value) => {
        let set = new Set(selectedIds);

        if(e.target.checked && !set.has(value)){
            set.add(value);
        } else if (!e.target.checked && set.has(value)){
            set.delete(value);
        }

        setSelectedIds(Array.from(set));
        setSelectedValue(null);
        setSelectedDate(null);
    }



    const openGenerateModal = () => {
        setGenerateModal(true);
    };
    const openRequisitionModal = () => {
        const vtypes = selectedIds.map(id => {
            const row = approvalrows.find(row => row.id === id);
            return row ? row.vtype : null;
        });
    
        const allSameVType = vtypes.every(vtype => vtype === vtypes[0]);
    
        if (!allSameVType) {
            toast.error('Selected rows have different vendor types');
            return;
        }
    
        const firstVType = vtypes[0];
        console.log("firstVType:", firstVType);
        if (firstVType !== null) {
            setFirstVType( vtypes[0])

            if (firstVType.toLowerCase() === "import") {

                setTaxInclude({value: 'NO', label: 'NO'})
                setIsConversion(false)
                setIsTax(true)
            } 
        }
        else if(!firstVType){
            toast.error('vendor type is missing in any of selected products')
            return
        }
        setRequisitionModal(true);

    };
    const closeRequisitionModal = () => {
        setRequisitionModal(false);
        setReference(null);
        setComment(null)
        setWorkflow(null)
        setTaxInclude(null);
        setFirstVType(null);
        setDescription(null)
        setLocation(null);
        setConversionRate(1);
        setCostcentre(null)
        setErrors({
            workflow: false,
            costcentre: false,
            location: false,
            tax_include: false,
            conversion_rate: false
        });  
        setIsConversion(true) 
        setIsTax(false)
    };
    const closeGenerateModal = () => {
        setGenerateModal(false);
        setSavedItem(false);
    }

    const handleButtonClick = () => {
        setIsEditMode(!isEditMode);
    };

    const handleCheckAll = (e) => {
        let isChecked = e.target.checked;
        let arr = [];

        if(isChecked){
            arr = approvalrows.map(el => el.id);
            setSelectedIds(arr);    
        } else {
            setSelectedIds(arr);
        }
    }

    const columns = [
        {
            field: 'Sl_No', headerName: (<div><Checkbox onChange={(e) => handleCheckAll(e)} /><span>SL.No</span></div>),
            // width: 100,
            sortable: false,
            resizable: false,
            flex: .8,
            renderCell: (params) => {
                return <div><Checkbox checked={new Set(selectedIds).has(params.row.id)} onChange={(e) => handleIdSelection(e, params.row.id)} /><span>{params.value}</span></div>;
            },
        },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            // width: 160,
            flex: 1,
            sortable: false,
            resizable: false,
            editable: false,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'Quantity',
            headerName: 'Quantity',
            headerClassName: 'table-header-background',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 0.7,
            //   width: 160,
        },
        // {
        //     field: 'MOP',
        //     headerName: 'FOB',
        //     sortable: false,
        //     resizable: false,
        //     // width: 160,
        //     flex: 1,
        // },
        {
            field: 'DP_Value',
            headerName: 'DP Value',
            sortable: false,
            resizable: false,
            flex: 1,
            // width: 160,
        },
        
        {
            field: 'mop',
            headerName: 'MOP',
            sortable: false,
            resizable: false,
            // width: 160,
            flex: 1,
            renderCell: (params) => {
                return (
                    <div >
                        {params.value.toFixed(2)}
                    </div>
                );
            },
        },
        // {
        //     field: 'TOTAL_DP_Value',
        //     headerName: 'TOTAL DP',
        //     sortable: false,
        //     resizable: false,
        //     flex: 1,
        //     // width: 160,
        //     renderCell: (params) => {
        //         return (
        //             <div >
        //                 {params.value.toFixed(2)}
        //             </div>
        //         );
        //     },
        // },
        {
            field: 'vendor_name',
            headerName: 'Vendor Name',
            sortable: false,
            resizable: false,
            //   cellClassName: 'product_name_wrap center-aligndata ',
            //   width: 160,
            flex: 1,
            // width: 160,

        },
        {
            field: 'payment_term',
            headerName: 'Payment Term',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div className="mt-1" style={{ cursor: 'pointer' }}>
                        {params.row.payment_opt_id ? paymentOptions?.filter(el => el.value == params.row.payment_opt_id)[0].label : '--' }
                      
                    </div>
                );
            },
            // width: 160,
        },
        {
            field: 'actual_date',
            headerName: 'Actual Date',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div className="mt-1" style={{ cursor: 'pointer' }}>
                        {params.row.arrival_date ? new Date(params.row.arrival_date).toDateString() : '--' }
                      
                    </div>
                );
            }
            // width: 160,

        },
        // {
        //     field: 'stock_in_hand',
        //     headerName: 'Stock In Hand',
        //     resizable: false,
        //     sortable: false,
        //     width: 160,
        //     flex: 1,
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        //      renderCell: (params) => (
        //         <div style={{ cursor: 'pointer' }} onClick={() => handleEyeIconClick(params)}>
        //             <VisibilityIcon sx={{color: "#5A6871"}} />
        //         </div>
               
        //     ),
        // },
    ];

    const handleEyeIconClick =async (params) => {
        try {
            const response = await getStockInHand({itemNo: params.row.Product_No})
            if(response.statusCode===200){
                setMergedArray({product_name: params.row.Product_Name, product_code: params.row.Product_No, stock_records: response.data.mergedArray
                })
                setOpen(true)

            }
        }catch(error){
            console.log('error in fetching stock in hand--', error)
            toast.error('Error in fetching stock in hand')
        }
        
    };
    const fetchProducts = async () => {
        try {
          setGridLoad(true);
    
          let productList, result;
          let payload ={}
          if(selectedVendor){
            payload.vendor_code = selectedVendor
          }
          if(product){
            payload.item_no = product
          }
          if(category){
            payload.category = category
          }
          productList = await fetchProductListForGeneratePO(payload)

          
          result = productList.data.distributedProductList;
          if (productList.statusCode === 200) {
            let formattedProducts =[]
            if(result.length > 0){

                 formattedProducts = result.map((product, index) => ({
                  id: product.id, // Assuming index + 1 as ID
                  Sl_No: index + 1, // Serial Number
                  Product_Name: product.item_name,
                  Product_No: product.item_no,
                  Quantity: product.total_qty,
                  Approved_Qty: 0,
                  DP_Value: product.dp || 0,
                  TOTAL_DP_Value: (product.dp * product.total_qty) || 0,
                  Single_DP_Value: product.dp || 0,
                  MOP: product.mop || 0,
                  TOTAL_MOP:(product.mop * product.total_qty) || 0,
                  Single_MOP: product.mop || 0,
                  ADJUSTED_Value: product.adjusted_value || 0,
                  vendor_name: product.v_name,
                  vendor_code: product.v_code,
                  status: product.status,
                  arrival_date:product.vendor_arrival_date,
                  payment_opt_id:product.payment_opt_id,
                  vtype: product.v_type
                }));
            }
    
            setApprovalrows(formattedProducts);
          }
        } catch (error) {
          toast.error("Error in fetching generate po list for purchase");
          console.log(error);
        } finally {
          setGridLoad(false);
        }
      };


    const fetchVendorList = async () => {
        try {
            if(!vendorListLoad){
                setVendorListLoad(true);
                const list = await fetchFilterListForAllocation({filter_type:['vendor','product','category']});
                if(list.statusCode === 200){
                    if(list.data.response.categoryList.length >0){
                        setCategoryOptions(list.data.response.categoryList)
                    }
                    if(list.data.response.productList.length >0){
                        setProductOptions(list.data.response.productList)
                    }
                    if(list.data.response.vendorList.length >0){
                        setVendorList(
                            list.data.response.vendorList
                          );
                    }
                }
              
            }
            
        } catch (error) {
          toast.error("Error in fetching vendor list for assign vendor");
          console.log(error);
        } finally {
          setVendorListLoad(false);
        }
      };

      const fetchAllPaymentOptions = async () => {
        try {
          setGridLoad(true);
          const paymentOptionsResponse = await fetchPaymentOptions();
          setPaymentOptions(
            paymentOptionsResponse.data.paymentOptions.map((el) => {
              return { label: el.label, value: el.id };
            })
          );
          
        } catch (error) {
          toast.error("Error in fetching payment options for generate po");
          console.log(error);
        } finally {
          setGridLoad(false);
        }
      };

      useEffect(() => {
        fetchAllPaymentOptions();
        fetchVendorList()
      }, []);

   
    useEffect(() => {
   
            fetchProducts();
      
      }, [selectedVendor, product, category])

    const handleUpdatePaymentOption = async (payment_opt) => {
        try {

        
            if(selectedIds.length){
                const updatePaymentAndActualDateResponse = await updatePaymentAndActualDate({
                    type: 'payment', payment_opt_id: payment_opt, distributed_id: selectedIds.map(el => ({id: el}))
                });
            
            if(updatePaymentAndActualDateResponse.statusCode == 200){
                toast.success("Successfully saved payment option");
                fetchProducts(selectedVendor);
            }
            }
            
            
          } catch (error) {
            toast.error("Error while updating payment option for generate po");
            console.log(error);
          }
    }

    const handleUpdateArrivalDate = async (date) => {
        try {
            if(selectedIds.length){

            const updatePaymentAndActualDateResponse = await updatePaymentAndActualDate({
                type: 'actual_date', actual_date: date, distributed_id: selectedIds.map(el => ({id: el}))
            });
            
            if(updatePaymentAndActualDateResponse.statusCode == 200){
                toast.success("Successfully saved arrival date");

                fetchProducts(selectedVendor);
            }
        }
            
          } catch (error) {
            toast.error("Error while updating arrival date for generate po");
            console.log(error);
          }
    }

    useEffect(() => {
        if(selectedValue){
        handleUpdatePaymentOption(selectedValue?.value);

        }
    }, [selectedValue]);

    useEffect(() => {
        if(selectedDate){
            handleUpdateArrivalDate(dayjs(selectedDate).format('YYYY-MM-DD')
            );

        }
    }, [selectedDate]);


    const handleDone = async () => {
        if(!isGeneratePOLoading){
            try{
                setGeneratePOLoading(true);
                console.log("workflow:", workflow);
                const data = {
                    po_total_adjusted_value: totalSum, 
                    vtype: firstVType,
                    po_items: approvalrows.filter(el => new Set(selectedIds).has(el.id)).map(el => ({
                        id: el.id,
                        vendor_code: el.vendor_code,
                        total_qty: el.Quantity,
                        item_no: el.Product_No,
                        actual_date:approvalrows.filter(el => el.id == selectedIds[0])[0].arrival_date,
                        dp: el.Single_DP_Value,
                        mop: el.Single_MOP,
                    })), 
                    v_name: approvalrows.filter(el => el.id == selectedIds[0])[0].vendor_name, 
                    v_code: approvalrows.filter(el => el.id == selectedIds[0])[0].vendor_code, 
                    actual_date: approvalrows.filter(el => el.id == selectedIds[0])[0].arrival_date, 
                    payment_opt_id: approvalrows.filter(el => el.id == selectedIds[0])[0].payment_opt_id
                }
                if(workflow){
                    data.workflow = workflow.value
                    data.workflow_id = workflow.id
                }
                if(costcentre){
                    data.costcentre = costcentre.value
                    data.costcentre_id = costcentre.id
                }
                if(description){
                    data.description = description

                }
                if(comment){
                    data.comment = comment

                }
                if(reference){
                    data.reference = reference
                }
                if(location){
                    data.location = location.value
                    data.location_id = location.id
                }
                if(taxInclude){
                    data.tax_include =taxInclude.value
                }
                if(conversionRate){
                    data.conversion_rate =Number(conversionRate)
                }
                
                if(+data.conversion_rate * +data.po_total_adjusted_value > 20000000){
                    setSendToManagementModal(true);
                } else {
                    let response = await generatePO(data);
                    if(response.statusCode === 200){
                        sweetAlertDisp(
                            'PO Generated successfully',
                            'success',
                            'ok'
                        )
                        setIsOpenSweetAlert(true);
                        handleReset()
                    }
                }
                
            } catch(err){
                sweetAlertDisp(
                    'Cannot Generate PO at the moment',
                    'error',
                    'Close'
                )
                setIsOpenSweetAlert(true);
                selectedIds([])
                console.log(err);
            } finally {
                closeGenerateModal();
                closeModal();
                setGeneratePOLoading(false);
                setSummaryModalIsOpen(false);
                closeRequisitionModal()

                
            }
        }
        
    }

    const handleReset = () => {
        fetchProducts();
        setSelectedIds([])
        setIsDisabled(true)
        setReference(null);
        setComment(null)
        setWorkflow(null)
        setTaxInclude(null);
        setFirstVType(null);
        setDescription(null)
        setLocation(null);
        setConversionRate(1);
        setCostcentre(null)
        setErrors({
            workflow: false,
            costcentre: false,
            location: false,
            tax_include: false,
            conversion_rate: false
        });  
        setIsConversion(true) 
        setIsTax(false)
        setSelectedValue(null);
        setSelectedDate(null);
    }

    const transferToManagement = async (isTransferred) => {
        try {
            if(isTransferred) {
                const data = {
                    product_distribution_id: selectedIds
                }
                await sendPoForManagementApproval(data)
                sweetAlertDisp(
                    'Successfully Transferred to Management',
                    'success',
                    'ok'
                );
            } else {
                sweetAlertDisp(
                    'Failed to Transfer to Management',
                    'error',
                    'close'
                );
            }
            setIsOpenSweetAlert(true);
            handleReset();
        } catch(err) {
            sweetAlertDisp(
                'Failed to Transfer to Management',
                'error',
                'close'
            );
            setIsOpenSweetAlert(true);
            console.log(err);
        } finally {
            setSendToManagementModal(false);
        }
    }

    const closeSendToManagementModal = () => {
        setSendToManagementModal(false);
    }

    const handleGeneratePOClick = () => {
                                        
        if(selectedIds.length < 1){
            toast.info("Select atleast 1 item for PO generation");
            return;
        }

        let selectedIdsSet = new Set(selectedIds);
        let ifNotArrivalDatePresent = !!approvalrows.filter(item => selectedIdsSet.has(item.id) && !item.arrival_date).length;
        let ifNotPaymentOptionPresent = !!approvalrows.filter(item => selectedIdsSet.has(item.id) && !item.payment_opt_id).length;
        
        if(ifNotArrivalDatePresent && ifNotPaymentOptionPresent){
            toast.error("Arrival Date is required!");
            toast.error("Payment Term is required!");
            return;
        }

        if(ifNotArrivalDatePresent){
            toast.error("Arrival Date is required!");
            return;
        }

        if(ifNotPaymentOptionPresent){
            toast.error("Payment Term is required!");
            return;
        }
        
        let arr = selectedIds.map(el => approvalrows.filter(item => item.id == el)[0].vendor_code);
        
        let set = new Set(arr);
        if(set.size > 1){
            toast.error("Cannot select different vendors for PO generation", {autoClose: 4000, position: 'top-center'});
            return;
        }

        arr = selectedIds.map(el => approvalrows.filter(item => item.id == el)[0].arrival_date);
        
        set = new Set(arr);
        if(set.size > 1){
            toast.error("Cannot select different Arrival Dates for PO generation", {autoClose: 4000, position: 'top-center'});
            return;
        }

        arr = selectedIds.map(el => approvalrows.filter(item => item.id == el)[0].payment_opt_id);
        
        set = new Set(arr);
        if(set.size > 1){
            toast.error("Cannot select different Payment Options for PO generation", {autoClose: 4000, position: 'top-center'});
            return;
        }

        openModal();
    }

    const handleVendorSelect = (e, myvalue, dropdownType) => {
        if(dropdownType === 'vendor'){

            setSelectedVendor(myvalue?.value || "");
        }
        if(dropdownType === 'product'){
            setProduct(myvalue?.value || "")
        }
        if(dropdownType === 'category'){
            setCategory(myvalue?.value || "")
        }
      };

    const handleSweetAlertConfirm = () => {
        sweetAlertDisp('', '', '');
        setIsOpenSweetAlert(false);
    };
    const handleStockClick = (isOpen) => {
        setOpen(isOpen)      
      };
      const handleAddBtn=async ()=>{
        try {
            let formIsValid = true;
            if (!workflow) {
                setErrors(prev => ({ ...prev, workflow: true }));
                formIsValid = false;
            }
            if (!costcentre) {
                setErrors(prev => ({ ...prev, costcentre: true }));
                formIsValid = false;
            }
            if (!location) {
                setErrors(prev => ({ ...prev, location: true }));
                formIsValid = false;
            }
            if (!taxInclude) {
                setErrors(prev => ({ ...prev, tax_include: true }));
                formIsValid = false;
            }
            if (!conversionRate) {
                setErrors(prev => ({ ...prev, conversion_rate: true }));
                formIsValid = false;
            }
            if (formIsValid) {
                await updatePODetails({
                    ids: selectedIds,
                    conversion_rate: conversionRate,
                });
                setRequisitionModal(false)
                setIsDisabled(false)
            }
        } catch (err) {
            toast.error(err.message);
        }
      }
    return (
        <React.Fragment>
              {
            open &&(
                <StockRightSideBar handleStockClick={handleStockClick}   mergedArray={mergedArray} // Pass selectedRowId
                />
            )
            }
            <div className="page-content">
                <Container fluid>
                    <div>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 className="mb-0 requisition_text">Generate PO</h4>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                            <div>
                                    <Autocomplete
                                        className="data_field"
                                        disablePortal
                                        id="combo-box-demo"
                                        options={paymentOptions}
                                        value={selectedValue}
                                        onChange={(event, newValue) => {
                                            setSelectedValue(newValue);
                                        }}
                                        inputValue={inputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setInputValue(newInputValue);
                                        }}
                                        sx={{ width: 190 }}
                                        renderInput={(params) => <TextField {...params} label="Choose Payment Term" />}
                                    />
                                </div>
                                <div style={{ cursor: 'pointer' }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            className='date_picker'
                                            value={selectedDate}
                                            onChange={(e) => {
                                                setSelectedDate(e)
                                            }}
                                            sx={{ width: 200, background: 'white' }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div><button disabled={isDisabled} className="assign_vendor" onClick={handleGeneratePOClick}>Generate PO</button></div>
                                {/* <div><button className="assign_vendor" onClick={openRequisitionModal} disabled={selectedIds.length === 0}><AddRoundedIcon />Requisition params</button></div> */}
                                {/* <div>
                                    <button onClick={toggleList} variant="outlined" className="filter_button"><span className="me-2"><TuneIcon /></span>Filter</button>
                                </div> */}
                            </div>
                        </div>
                        {showList && (
                            <div className="d-flex align-items-center gap-2 flex-wrap mt-3">
                                <div>
                                    <Autocomplete
                                        className="data_field"
                                        disablePortal
                                        id="combo-box-demo"
                                        options={vendorList}
                                        sx={{ width: 170 }}
                                        onInputChange={(event, newValue) => handleVendorSelect(event, vendorList.find(el => el.label == newValue), 'vendor')}
                                        onChange={(event, newValue) => handleVendorSelect(event, newValue, 'vendor')}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Vendor" />
                                        )}
                                    />
                                </div>
                                <div>
                                    <Autocomplete
                                        className="data_field"
                                        disablePortal
                                        id="combo-box-demo"
                                        options={productOptions}
                                        sx={{ width: 170 }}
                                        onInputChange={(event, newValue) => handleVendorSelect(event, productOptions.find(el => el.label == newValue), 'product')}
                                        onChange={(event, newValue) => handleVendorSelect(event, newValue, 'product')}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Product" />
                                        )}
                                    />
                                </div>
                                <div>
                                    <Autocomplete
                                        className="data_field"
                                        disablePortal
                                        id="combo-box-demo"
                                        options={categoryOptions}
                                        sx={{ width: 170 }}
                                        onInputChange={(event, newValue) => handleVendorSelect(event, categoryOptions.find(el => el.label == newValue), 'category')}
                                        onChange={(event, newValue) => handleVendorSelect(event, newValue, 'category')}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Category" />
                                        )}
                                    />
                                </div>
                               
                            </div>
                          )}
                        

                        <Box sx={{ height: '100%', width: '100%', marginBottom: '10px', marginTop: '10px' }}>
                            <DataGrid
                                autoHeight
                                className="table_header_background"
                                headerClassName="custom-header-cell"
                                getRowHeight={() => 'auto'}
                                rows={approvalrows}
                                columns={columns}
                                loading={gridLoad}
                                initialState={{
                                    // pagination: {
                                    //   page: 1,
                                    // },
                                  }}

                                // initialState={{
                                //     pagination: {
                                //         paginationModel: {
                                //             pageSize: 5,
                                //         },
                                //     },
                                // }}
                                pageSizeOptions={[]}
                                disableRowSelectionOnClick
                                disableColumnMenu
                                disableColumnResize={true}
                                componentsProps={{
                                    cell: {
                                        disableClick: true,
                                    },
                                }}
                                sx={{
                                    '& .MuiDataGrid-cell': {
                                        '& .MuiDataGrid-cell--textOverflow': {
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </div>
                    {/* <Card>
                        <CardBody className="ps-0 pe-0 pt-0">
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th className="text-center">Item Count</th>
                                            <th className="text-center">Total Quantity</th>
                                            <th className="text-center">Total FOB</th>

                                            <th className="text-center">Total DP Value</th>

                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td className="text-center">{approvalrows.length}</td>
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Quantity;
                                                }, 0)}</td>
                                                
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.TOTAL_MOP;
                                                }, 0).toFixed(2)}</td>
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.TOTAL_DP_Value;
                                                }, 0).toFixed(2)}</td>
                                            </tr>
                                        
                                    </tbody>
                                  
                                </table>
                            </div>
                        </CardBody>
                    </Card> */}
                </Container>
            </div>
            <Modal
                isOpen={requisitionModal}
                onRequestClose={closeRequisitionModal}
                contentLabel="Example Modal"
                className="modal_box generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Add requisition parameters</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeRequisitionModal}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'>Add Requisition Params</hr> */}
                <ModalBody className='pt-2'>
                
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', flexBasis: 'calc(50% - 10px)' }}>
                            <div style={{ marginBottom: '20px' }}>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="workflow-autocomplete"
                                    options={workflowList}
                                    value={workflow}
                                    sx={{ width: 250 }}
                                    onChange={handleWorkflowChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Workflow" />
                                    )}
                                />
                                {errors.workflow && <div style={{ color: 'red' }}>Workflow is required</div>}

                            </div>
                            <div>
                               
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="costcentre-autocomplete"
                                    options={costcentreOptions}
                                    sx={{ width: 250 }}
                                    value={costcentre}
                                    onChange={handleCostCentreChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Costcentre" />
                                    )}
                                />
                                {errors.costcentre && <div style={{ color: 'red' }}>Costcentre is required</div>}

                            </div>
                        </div>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', flexBasis: 'calc(50% - 10px)' }}>
                            <div style={{ marginBottom: '20px' }}>
                            <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="costcentre-autocomplete"
                                    options={locationList}
                                    sx={{ width: 250 }}
                                    value={location}
                                    onChange={handleLocationChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Location" />
                                    )}
                                />
                                    {errors.location && <div style={{ color: 'red' }}>Location is required</div>}
                            </div>
                            <div>
                                <TextField id="standard-basic" label="Description" variant="outlined" value={description}
                                    onChange={handleDescription} />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', flexBasis: 'calc(50% - 10px)' }}>
                            <div style={{ marginBottom: '20px' }}>
                                <TextField id="standard-basic" label="Reference" variant="outlined"  value={reference}
                                    onChange={handleReference} />
                            </div>
                            <div>
                                <TextField id="standard-basic" label="Comments" variant="outlined" value={comment}
                                    onChange={handleComments}/>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', flexBasis: 'calc(50% - 10px)' }}>
                            <div style={{ marginBottom: '20px' }}>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="tax-autocomplete"
                                    options={taxOptions}
                                    value={taxInclude}
                                    sx={{ width: 250 }}
                                    onChange={handleTaxIncludeChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Tax include" />
                                    )}
                                    disabled={isTax}
                                />
                                {errors.tax_include && <div style={{ color: 'red' }}>Tax is required</div>}

                            </div>
                            <div>
                                <TextField id="standard-basic" label="Exchange rate" variant="outlined"  value={conversionRate}
                                    onChange={handleChangeRate}
                                    type="number" disabled={isConversion} />
                                    {errors.conversion_rate && <div style={{ color: 'red' }}>Exchange rate is required</div>}
                            </div>
                        </div>
                    </div>

                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <Button onClick={handleAddBtn}>Add</Button>
                </ModalBody>
            </Modal>
           
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
            >
                <div>
                    <div className='d-flex justify-content-end me-3 modal_close p-2'>
                        <i class="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <ModalBody className='pt-2'>
                    <div>
                        <div className='hand_img'>
                            <img src={handImg} />
                        </div>
                        <div className="mt-3">
                            <h4 className='text-center'>Do You Want To Change The Value</h4>
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" onClick={openGenerateModal}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" disabled={isGeneratePOLoading} onClick={() => setSummaryModalIsOpen(true)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
          
            <Modal
                isOpen={generateModal}
                onRequestClose={closeGenerateModal}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Change Value</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeGenerateModal}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    

                        <table id="table" className='requisition_balance'>
                            <thead className='booked_balance_listHeader'>
                                <tr>
                                    <th className="text-center">Sl No.</th>
                                    <th className="text-center">Product Name</th>
                                    <th className="text-center">Quantity</th>
                                    <th className="text-center">DP Value</th>
                                    <th className="text-center">FOB</th>
                                    <th className="text-center">Vendor Name</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody className='requisition_balance_table_body'>

                                {approvalrows.filter(el => new Set(selectedIds).has(el.id)).map((item, idx) => (
                                    <tr key={idx}>
                                        <td className="text-center">{item.Sl_No}</td>
                                        <td className="text-center">{item.Product_Name}</td>
                                        <td className="text-center">{item.Quantity}</td>
                                        <td className="text-center">{item.DP_Value}</td>
                                        <td className="text-center">
                                            {!modifyRowMap[item.id]
                                             ? (
                                                <p className="mb-0">{item.MOP}</p>
                                            ) : (
                                                <input className="generate_input" type="text" value={allocationQtyMap[item.id]} onChange={(e) => {
                                                    let obj = {...allocationQtyMap};
                                                    obj[item.id] = e.target.value;
                                                    setAllocationQtyMap(obj);
                                                }}></input>
                                            )}</td>
                                        <td className="text-center">{item.vendor_name}</td>
                                        <td className="text-center">  {!modifyRowMap[item.id] ? (
                                            <div className="d-flex gap-2 align-items-center">
                                            <button onClick={() => handleEditClick(item.id)} className="no_button p-1 ps-4 pe-4 d-flex align-items-center">Edit</button>
                                            <button
                                            className="no_button p-1 ps-4 pe-4"
                                            onClick={() => handleSave(item.id)}
                                        >
                                            Save
                                        </button>
                                        </div>
                                        ) : (
                                            <button onClick={() => handleSave(item.id)} className="no_button p-1 ps-3 pe-3">Modified</button>
                                        )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" onClick={handleSaveAll}>
                            Save All
                        </button>


                        <button className="yes_button d-flex align-items-center ms-2" disabled={!savedItem || isGeneratePOLoading} onClick={() => setSummaryModalIsOpen(true)}>
                            Done
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal
                isOpen={sendToManagementModal}
                onRequestClose={closeSendToManagementModal}
                contentLabel="Example Modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Transfer PO request to Management</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeSendToManagementModal}></i>
                    </div>
                </div>
                <ModalBody className='pt-2'>
                    <div>
                        <div className='hand_img'>
                            <img src={handImg} />
                        </div>
                        <div className="mt-3">
                            <h4 className='text-center'>The PO value exceeds 2 crores. Need management approval.</h4>
                        </div>
                    </div>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" onClick={() => transferToManagement(true)}>
                            Yes
                        </button>
                        <button className="yes_button d-flex align-items-center ms-2" onClick={() => transferToManagement(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal
                isOpen={summaryModalIsOpen}
                onRequestClose={() => setSummaryModalIsOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to generate this PO?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSummaryModalIsOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Product</th>

                                            <th>Vendor</th>
                                            <th>Quantity</th>
                                            
                                            <th>Total FOB</th>
                                            <th>Total DP</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        {approvalrows.filter(el => new Set(selectedIds).has(el.id)).map((row, index) => (
                                            <tr key={row.value}>
                                                <td>{++index}</td>
                                                <td>{row.Product_Name}</td>
                                                <td>{row.vendor_name}</td>
                                                <td>{row.Quantity}</td>

                                                <td>{row.TOTAL_MOP}</td>
                                                <td>{row.TOTAL_DP_Value}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{approvalrows.filter(el => new Set(selectedIds).has(el.id)).reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Quantity;
                                                }, 0)}</td>
                                            <td>{approvalrows.filter(el => new Set(selectedIds).has(el.id)).reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.TOTAL_MOP;
                                                }, 0)}</td>
                                            <td>{approvalrows.filter(el => new Set(selectedIds).has(el.id)).reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.TOTAL_DP_Value;
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={isGeneratePOLoading} onClick={handleDone}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSummaryModalIsOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            <SweetAlert
                show={isOpenSweetAlert}
                title={sweetAlertTitle}
                type={sweetAlertType}
                confirmButtonText={sweetAlertConfirmButtonText}
                confirmBtnBsStyle={sweetAlertTitle}
                onConfirm={handleSweetAlertConfirm}
            />
        </React.Fragment>
    );
};

export default GeneratePo;
